/**
 * Junta nomes de classe, descartando valores falsos.
 *
 * Evita a dependencia de `clsx` para o unico caso que o projeto precisa.
 */
export function cn(...values: (string | false | null | undefined)[]): string {
  return values.filter(Boolean).join(' ');
}
